module.exports = __webpack_public_path__ + "static/media/no-brands-error.820fe2da.png";